import { createAsyncThunk } from '@reduxjs/toolkit';
import { tokenService } from '../../token.service';

export const logoutThunk = createAsyncThunk('logout', () => {
  tokenService.clear();
  return Promise.resolve();
});
